<style lang="scss">
  @import 'styles/overrides.scss';
  @import 'styles/custom.scss';
</style>
<style>
* {
    font-family: "e-Ukraine", ProbaPro, sans serif !important;
    font-style: ultra-light;
    color: #000;
    letter-spacing: -0.02em !important;
  }
  .data-table-date-col-width {
    width: 180px;
  }
  .fifty-width {
    width: 50%;
    white-space: normal;
  }
  .fifty-table table {
    table-layout : fixed;
  }
  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 10px 24px !important;
  }

  .v-slide-group__prev, .v-slide-group__prev--disabled {
    min-width: 0px !important;
    flex: 0px !important;
  }
  .view-href-chip {
    border: 2px solid black !important; 
    background-color: white !important;
  }
  .view-href-chip:hover {
    color: #fff;
    background-color: black !important;
  }
  .view-href-a {
    font-size: 13px;
    font-weight: normal;
    color: black !important;
    text-decoration: none !important;
    box-sizing: border-box;
    border: 2px solid black !important;
    padding: 10px 24px;
    border-radius: 20px;
    line-height: 1;
  }
  .view-href-a:hover {
    color: #fff !important;
    text-decoration: none !important;
    background-color: black !important;
  }
  .diia-a-style {
    color: #fff !important;
    text-decoration: none;
  }
  .diia-a-style:hover {
    text-decoration: underline;
  }
  /* .diia-side-nav-item {

  } */
  .theme--light.v-list-item:focus::before, .theme--light.v-list-item--active::before, .theme--light.v-list-item:hover::before, .theme--light.v-list-item--active:focus::before {
    background-color: transparent !important;
    opacity: 0 !important;
  }
  .theme--light.v-list-item--active {
    font-weight: bold !important;
  }

  .diia-side-nav-item:hover > v-list-item--link:before {
    background-color: #fff !important;
  }
  .diia-side-nav-item:active {
    background-color: #fff !important;
  }
  .diia-side-nav-item:hover {
    text-decoration: underline;
  }
  .v-list-item--link:hover {
    background-color: #fff !important;
    color: #000 !important; 
  }
  
  .theme--light.v-list-item--link {
    color: #ffffff !important;
  }
  .theme--light.v-list-item--link:hover {
    color: #000 !important;
  }
  .v-list-item--link:before {
    background-color: #000 !important;
  }


  .catalog-top-nav-router-link {
    text-decoration: none;
    line-height: 1;
  }
  .catalog-top-nav-item {
    color: #000 !important;
    margin: 0px 10px;
    font-size: 14px;
    text-decoration: none;
  }


  .catalog-top-nav-item:hover {
    text-decoration: underline;
  }

  .v-data-table__progress.primary {
    background-color: red !important;
  }

  .burger_menu_icon {
    padding: 0px !important;
    min-width: 20px !important;
    height: 36px !important;
  }

  .burger_menu_icon:hover::before {
    opacity: 0 !important;
  }

  .burger_menu_icon > .v-ripple__container {
    display: none !important;
  }

  .burger_menu_icon > .v-btn__content {
    padding: 0px !important;
  }

  .burger_menu_icon > .v-btn__content >.v-icon.v-icon {
    font-size: 30px !important;
    color: #000;
  }

  .burger_menu_icon > .v-btn__content >.v-icon.v-icon:focus::after {
    opacity: 0 !important;
  }


  .burger_menu_icon__large {
    padding: 0px !important;
    min-width: 24px !important;
    height: 36px !important;
  }

  .burger_menu_icon__large:hover::before {
    opacity: 0 !important;
  }

  .burger_menu_icon__large > .v-ripple__container {
    display: none !important;
  }

  .burger_menu_icon__large > .v-btn__content {
    padding: 0px !important;
    transition: none !important;
  }

  .burger_menu_icon__large > .v-btn__content >.v-icon.v-icon {
    font-size: 48px !important;
    color: #000;
    transition: none !important;
  }

  .burger_menu_icon__large > .v-btn__content >.v-icon.v-icon {
    font-size: 48px !important;
    color: #000;
    transition: none !important;
  }

  .burger_menu_icon__large > .v-btn__content >.v-icon.v-icon:focus::after {
    opacity: 0 !important;
  }


  .instance_switch {
    line-height: 1px; 
    font-size: 12px;
  }
  .instance_switch:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }


  .background-diia {
      border-radius: 0px !important; 
      background-image: linear-gradient(to right, #9cedff 0%, #4dcee8 100%);
      background-size: 200% 300%;
      background-attachment: fixed;
    }

    @-webkit-keyframes granimate {
        0%,
        100% {
            background-position: 0 25%;
        }
        25%,
        75% {
            background-position: 50% 50%;
        }
        50% {
            background-position: 100% 100%;
        }
    }

    @keyframes granimate {
        0%,
        100% {
            background-position: 0 25%;
        }
        25%,
        75% {
            background-position: 50% 50%;
        }
        50% {
            background-position: 100% 100%;
        }
    }

  .with-border-bottom {
    border-bottom: 2px black solid;
  }

  @media only screen and (max-width: 1264px) {
    .with-border-bottom {
        border-bottom: 2px black solid;
    }
  }

  .top-auth-button {
    margin-left: 36px !important; 
    padding: 13px 22px 13px !important; 
    font-size: 13px !important; 
    border-radius: 50px !important; 
    line-height: 16px !important; 
    letter-spacing: normal !important; 
    text-transform: none !important; 
    align-items: center !important;
    background-color: #000 !important;
    color: #fff !important;
    font-style: normal !important;
    font-weight: 400 !important;
    display: inline-block !important;
    height: auto !important;
  }

  .top-auth-button:hover {
    /* background-image: linear-gradient(87.92deg, #2833d0, #7179ef 34.8%, #bf98c6 70.37%, #f1acac 118.85%); */
    background: linear-gradient(74.48deg, #0353E3 17.93%, #00D4FF 80.39%);
    transition: all .3s;
}


</style>

<template>
<v-app>
    <!-- MAIN -->
  <v-main>
      <v-container style="max-width: 1680px;" class="pa-0">
        <v-card
          fluid
          elevation="0"
          class="mr-0 container-side-padding"
          
        >
          <div class="d-flex justify-space-between pa-0 pt-6 pb-6 mb-0 align-center with-border-bottom">
            <span class="display-inline">
              <a :href="$config.website_redirect_url">
                <img src="./assets/logo.svg" alt="Трембіта" height="36px" style="vertical-align: middle;"/>
              </a>
            </span>
            <div style="display: flex; align-items: center;">

              <v-progress-circular v-if="auth_data_on_load" indeterminate size="28" style="opacity: 0.6;"></v-progress-circular>
              <span v-show="$vuetify.breakpoint.lgAndUp" v-if="!auth_data_on_load && $authData" style="font-size: 13px;">Організація: {{ $authData.access.o }}</span>
              <v-btn :ripple="false" class="d-none d-lg-inline-flex top-auth-button" elevation="0" @click="goToAuth()">{{ auth_button_text }}</v-btn>
              <v-btn
                  large
                  elevation="0"
                  color="transparent"
                  class="burger_menu_icon d-inline-flex d-lg-none justify-end"
                >
                <v-icon @click="switchNavMenu()">mdi-menu</v-icon>
              </v-btn>
            </div>
            <v-dialog
              v-model="nav_menu_dialog"
              fullscreen
              hide-overlay
              transition="slide-x-transition"
            >
              <v-card tile>
                <v-container fluid class="pa-0">
                  <v-list>
                    <v-list-item class="justify-end align-center ma-0 pa-0 ml-5 mr-5 pt-1 pb-2" style="border-bottom: 2px black solid;">
                      <img src="./assets/logo.svg" alt="Трембіта" height="32px" style="vertical-align: middle;"/>
                      <v-spacer></v-spacer>
                      <v-btn
                          large
                          elevation="0"
                          color="transparent"
                          class="burger_menu_icon"
                      >
                          <v-icon @click="switchNavMenu()">mdi-close</v-icon>
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="justify-start mt-8 pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'root', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Каталог</a>
                      </router-link>
                    </v-list-item>
                    <!-- <v-divider></v-divider> -->
                    <!-- <v-list-item class="justify-start">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'stats', query: {'env': $config.query_params.env} }">
                        <a @click="switchNavMenu()" class="mb-2">Статистика</a>
                      </router-link>
                    </v-list-item> -->

                    <v-list-item class="justify-start mt-8 pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'organizations-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Організації</a>
                      </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'information-resources-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Е-ресурси</a>
                      </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'subsystems-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Підсистеми</a>
                      </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'interfaces-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Інтерфейси е-ресурсів</a>
                      </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'services-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Сервіси</a>
                      </router-link>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'interactions-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Взаємодії</a>
                      </router-link>
                    </v-list-item>
                    <v-divider v-if="authData"></v-divider>
                    <v-list-item class="justify-start pl-5 pr-5" v-if="authData">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'servers-list', query: {'env': $config.query_params.env}}">
                        <a @click="switchNavMenu()" class="mb-2">Шлюзи безпечного обміну</a>
                      </router-link>
                    </v-list-item>
                    <v-list-item class="justify-start mt-8 pl-5 pr-5" v-if="!auth_data_on_load && $authData">
                      <span style="font-size: 13px;">Організація: {{ $authData.access.o }}</span>
                    </v-list-item>
                    <v-list-item class="justify-start mt-8 pl-5 pr-5">
                      <router-link class="catalog-top-nav-router-link" :to="{name: 'catalog', query: {'env': $config.query_params.env}}">
                        <a @click="goToAuth()" class="mb-2">Увійти до особистого кабінету</a>
                      </router-link>
                    </v-list-item>
                  </v-list>
                </v-container>
              </v-card>
            </v-dialog>
          </div>
        </v-card>
      </v-container>
      <v-container style="max-width: 1680px;" class="pa-0">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
        <v-card style="background-color: rgba(0,0,0);" dark>
          <v-container style="max-width: 1680px;" class="container-side-padding pt-10 pb-10">
              <v-row>
                <v-col cols="12" md="6" style="color: #ffffff; font-size: 12px;">
                  <img src="./assets/logo.mincifra.svg" alt="Мінцифра логотип" width="220">
                </v-col>
                <v-col cols="12" md="6" style="color: #ffffff; font-size: 12px;">
                  <a href="/" class="diia-a-style">Каталог</a>
                  <!-- <v-spacer class="mt-3 mb-3"></v-spacer>
                  <a href="/qa" class="diia-a-style">Питання та відповіді</a> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12"><v-divider style="background-color: #4C4C4C;" class="mt-5 mb-5"></v-divider></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" style="color: #ffffff; font-size: 12px;">{{ $config.translation.ua.FOOTER_LEFT_TEXT }}</v-col>
                <v-col cols="12" md="6" style="color: #ffffff; font-size: 12px;">{{ $config.translation.ua.FOOTER_RIGHT_TEXT }}</v-col>
              </v-row>
          </v-container>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';


export default {
  name: "App",
  components: {},
  data: () => ({
    env: 'SEVDEIR',
    nav_menu_dialog: false,
    auth_user_name_surname: "",
    auth_button_text: "Увійти до кабінету",
    auth_organization_top_text: "",

    auth_data_on_load: false,
  }),
  /* eslint-disable */
  created: function () {
    document.title = 'Каталог веб-сервісів';

    console.log(localStorage.getItem('organization_list_headers'));

    if (!localStorage.getItem('organization_list_headers')) {
        localStorage.setItem('organization_list_headers', this.$config.configuration.organization.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('eresource_list_headers')) {
        localStorage.setItem('eresource_list_headers', this.$config.configuration.information_resource.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('subsystem_list_headers')) {
        localStorage.setItem('subsystem_list_headers', this.$config.configuration.subsystem.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('interface_list_headers')) {
        localStorage.setItem('interface_list_headers', this.$config.configuration.information_resource_interface.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('service_list_headers')) {
        localStorage.setItem('service_list_headers', this.$config.configuration.service.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('interaction_list_headers')) {
        localStorage.setItem('interaction_list_headers', this.$config.configuration.interaction.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }
    if (!localStorage.getItem('server_list_headers')) {
        localStorage.setItem('server_list_headers', this.$config.configuration.server.list.items.filter(item => item.default == true).map(item => item.value).join(','));
    }

    if (!localStorage.getItem('organization_list_order')) {
        localStorage.setItem('organization_list_order', this.$config.configuration.organization.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('eresource_list_order')) {
        localStorage.setItem('eresource_list_order', this.$config.configuration.information_resource.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('subsystem_list_order')) {
        localStorage.setItem('subsystem_list_order', this.$config.configuration.subsystem.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('interface_list_order')) {
        localStorage.setItem('interface_list_order', this.$config.configuration.information_resource_interface.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('service_list_order')) {
        localStorage.setItem('service_list_order', this.$config.configuration.service.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('interaction_list_order')) {
        localStorage.setItem('interaction_list_order', this.$config.configuration.interaction.list.items.map(item => item.value).join(','));
    }
    if (!localStorage.getItem('server_list_order')) {
        localStorage.setItem('server_list_order', this.$config.configuration.server.list.items.map(item => item.value).join(','));
    }


    const saved_token = localStorage.getItem('token');
    if (saved_token != "" && saved_token !== null) {
        console.log(saved_token);
        this.auth_data_on_load = true;
        const decoded_token = JSON.parse(decodeURIComponent(escape(window.atob( saved_token.split('.')[1] ))));
        var timeInMs = Date.now();
        if (timeInMs > decoded_token.exp * 1000) {
            console.log("Час дії токену вичерпано");
            localStorage.setItem('token', "");
            this.updateAuthData("");
        } else {
            this.$authData = decoded_token;
            this.updateAuthData(decoded_token);
            this.auth_button_text = decoded_token.first_name + " " + decoded_token.last_name;
        }
    } else {
        this.auth_data_on_load = false;
    }

    // Load new token
    let this_context = this;
    let bStore = this.$crossServer(this.$config.cabinet_url + '/accessStorage');
    bStore.get('token', function(error, value) {
        console.log(bStore);
        bStore.close();
        if (value) {
          console.log("TOOOKEN?");
          console.log(value);
          const decoded_token = JSON.parse(decodeURIComponent(escape(window.atob( value.split('.')[1] ))));
          var timeInMs = Date.now();
          if (timeInMs > decoded_token.exp * 1000) {
              console.log("Час дії токену вичерпано");
              this_context.updateAuthData("");
              localStorage.setItem('token', "");
          } else {
              localStorage.setItem('token', value);
              this_context.$authData = decoded_token;
              this_context.updateAuthData(decoded_token);
              this_context.auth_button_text = decoded_token.first_name + " " + decoded_token.last_name;
              console.log("Token set, and not empty or expired");
          }
        } else {
          localStorage.setItem('token', "");
          console.log("Token not set, or error");
          console.log(error);
        }
        this_context.updateFreshTokenRetrievalTransactionCompleted(true);
        this_context.auth_data_on_load = false;
    });

    // this.handleToken(bStore);

    if (this.$route.query.env) {
        this.$config.query_params.env = this.$route.query.env;
        this.env = this.$route.query.env;
    }
    else if (this.$config.query_params.env != 'SEVDEIR' && this.$config.query_params.env != 'SEVDEIR-TEST') {
        this.$config.query_params.env = 'SEVDEIR';
        this.env = 'SEVDEIR';
    }

    if (!this.$route.query.env) {
        this.$router.replace({name: this.$route.name, query: this.$config.query_params});
    }
  },
  mounted: function() {
    function receiveMessage(e) {
    // Check to make sure that this message came from the correct domain.
      // if (e.origin !== "https://internal-web-dev.trembita.gov.ua")
      //   return;
      // Update the div element to display the message.
      console.log(e.data);
    }

    // Setup an event listener that calls receiveMessage() when the window
    // receives a new MessageEvent.
    this.$el.addEventListener('message', receiveMessage);
  },
  updated: function () {
      this.$nextTick(function () {
        if (this.$route.query.env) {
            this.$config.query_params.env = this.$route.query.env;
            this.env = this.$route.query.env;
        }
        else if (this.$config.query_params.env != 'SEVDEIR' && this.$config.query_params.env != 'SEVDEIR-TEST') {
            this.$config.query_params.env = 'SEVDEIR';
            this.env = 'SEVDEIR';
        }

        if (!this.$route.query.env) {
            this.$router.replace({name: this.$route.name, query: this.$config.query_params});
        }
        // Code that will run only after the
        // entire view has been re-rendered
    })
  },

  watch: {
      $route(to, from) {
          document.title = to.meta.title || 'Каталог системи Трембіта';
          window.scrollTo(0, 0);
      },

  },

  methods: {
    ...mapActions(['authData', 'updateAuthData', 'updateFreshTokenRetrievalTransactionCompleted']),

    goToAuth() {
      window.open(this.$config.cabinet_auth_url);
    },
    switchNavMenu() {
      this.nav_menu_dialog = !this.nav_menu_dialog;
    },
    switchEnv() {
        if (this.env == 'SEVDEIR') {
            this.$config.query_params.env = 'SEVDEIR-TEST';
            this.$router.replace({name: 'organizations-list', query: this.$config.query_params});
            this.$router.go();
        } else {
            this.$config.query_params.env = 'SEVDEIR';
            this.$router.replace({name: 'organizations-list', query: this.$config.query_params});
            this.$router.go();
        }
    },

    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },

    /* eslint-enable */
  }
};
</script>